import React, {useState} from 'react';


import * as styleUtils from '../../../utils/styleUtils';

import LanguageSymbolIcon from '../../../public/images/icons/icon-language-symbols.svg';
import {I18nMessage, usePlatformLanguages} from '../../contexts/I18n';
import {Icon, iconConstants} from '../Icon';
import {useUpdateUser, useUserLocaleTag} from '../../contexts/User';


import styles from './PlatformLanguageSwitcher.scss';


function PlatformLanguageSwitcher() {

    const [isOpen, setIsOpen] = useState(false);

    const userLocaleTag = useUserLocaleTag();
    const platformLanguages = usePlatformLanguages();
    const updateUser = useUpdateUser();
    const selectableLangauges = platformLanguages.filter(({tag}) => userLocaleTag !== tag);

    return (
        <div className={styles.platformLanguageSwitcher}>

            <div className={styleUtils.toClasses(styles.toggleBox, isOpen ? styles.open : null)}>
                <a
                    className={styles.toggleLink}
                    onClick={event => {

                        event.preventDefault();
                        setIsOpen(!isOpen);
                    }}
                >
                    <LanguageSymbolIcon/>
                    <I18nMessage id={`language.${userLocaleTag}`}/>
                    <Icon
                        icon={
                            isOpen
                                ? iconConstants.ICON_TRIANGLE_TOP
                                : iconConstants.ICON_TRIANGLE_BOTTOM
                        }
                    />
                </a>

                {isOpen && (
                    <div className={styles.languageSelection}>
                        {selectableLangauges.map(({tag}) => (
                            <a
                                key={`selectable-language-${tag}`}
                                onClick={event => {

                                    event.preventDefault();
                                    updateUser({locale: tag});
                                    setIsOpen(false);
                                }}
                            >
                                <I18nMessage id={`language.${tag}`}/>
                            </a>
                        ))}
                    </div>
                )}
            </div>

        </div>
    );
}


PlatformLanguageSwitcher.propTypes = {};

PlatformLanguageSwitcher.defaultProps = {};


export default PlatformLanguageSwitcher;
